<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0">

        <v-layout row px-10 mb-4 justify-center>
            <v-flex md10 pa-10>
                <div class="app_border layout__overflow-hidden">
                    <div v-show="newTemplate == true"><h1 class="text--teal">Create Template</h1></div>
                    <div v-show="newTemplate == false"><h1 class="text--teal">Edit Template</h1></div>

                    <v-container>
                        <div class="width-50">
                            <v-form ref="form" v-model="isFormValid" :lazy-validation="lazy">
                                <v-row class="no-margin-bottom layout__margin__top-10" v-show="newTemplate == true">
                                    <v-col class="templateColumn">
                                        <v-select
                                            v-model="stateFile"
                                            :items="stateFiles"
                                            label="Template state file"
                                            item-value="stateId"
                                            item-text="stateId"
                                            return-object
                                            @change="onStateFileChange()"
                                        >
                                            <template slot='selection' slot-scope='{ item }'>
                                                {{ item.stateId }}
                                            </template>
                                            <template slot='item' slot-scope='{ item }'>
                                                {{ item.stateId }}
                                            </template>
                                        </v-select>
                                    </v-col>
                                </v-row>

                                <div  v-show="newTemplate == false">
                                    <v-text-field
                                        v-model="existingFile"
                                        ref="existingFile"
                                        label="Existing Template File"
                                        readonly
                                    ></v-text-field>
                                </div>

                                <v-text-field
                                    v-model="templateName"
                                    ref="templateName"
                                    :rules="[v => !!v || 'Template name is required']"
                                    label="Template Name"
                                    clearable
                                    required
                                ></v-text-field>

                                <v-text-field
                                    v-model="previewImageFront"
                                    ref="previewImageFront"
                                    :rules="[v => !!v || 'Preview image (front) is required']"
                                    label="Preview Image (Front)"
                                    clearable
                                    required
                                ></v-text-field>

                                <v-text-field
                                    v-model="previewImageBack"
                                    ref="previewImageBack"
                                    :rules="[v => !!v || 'Preview image (back) is required']"
                                    label="Preview Image (Back)"
                                    clearable
                                    required
                                ></v-text-field>

                                <v-row class="no-margin-bottom layout__margin__top-10">
                                    <v-col class="templateColumn">
                                        <v-select
                                            v-model="productCode"
                                            :items="productCodes"
                                            :rules="[v => !!v || 'Product code is required']"
                                            label="Product Code"
                                            item-value="code"
                                            item-text="code"
                                            return-object
                                            @change="onProductCodeChange()"
                                        >
                                            <template slot='selection' slot-scope='{ item }'>
                                                {{ item.code }} - {{ item.description }}
                                            </template>
                                            <template slot='item' slot-scope='{ item }'>
                                                {{ item.code }} - {{ item.description }}
                                            </template>
                                        </v-select>
                                    </v-col>
                                </v-row>

                                <v-row class="no-margin-bottom layout__margin__top-minus-15">
                                    <v-col class="folder">
                                        <v-select
                                            v-model="folder"
                                            :items="folders"
                                            :rules="[v => !!v || 'Folder is required']"
                                            label="Folder"
                                            item-value="folder"
                                            item-text="folder"
                                            required
                                        >
                                            <template slot='selection' slot-scope='{ item }'>
                                                {{ item.folder }}
                                            </template>
                                            <template slot='item' slot-scope='{ item }'>
                                                {{ item.folder }}
                                            </template>                                        
                                        </v-select>
                                    </v-col>

                                    <v-col>
                                        <v-text-field
                                            v-model="width"
                                            :rules="[v => !!v || 'Width is required']"
                                            label="Width"
                                            clearable
                                            required
                                        ></v-text-field>
                                    </v-col>

                                    <v-col>
                                        <v-text-field
                                            v-model="height"
                                            :rules="[v => !!v || 'Height is required']"
                                            label="Height"
                                            clearable
                                            required
                                        ></v-text-field>
                                    </v-col>

                                    <v-col>
                                        <v-text-field
                                            v-model="pages"
                                            :rules="[v => !!v || 'No of pages is required']"
                                            label="No of Pages"
                                            clearable
                                            required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row class="no-margin-bottom layout__margin__top-minus-15">
                                    <v-col class="templateColumn">
                                        <v-checkbox
                                            class="layout__margin-0"
                                            v-model="genericTemplate"
                                            label="Set as generic template"
                                            :disabled="!newTemplate"
                                            required
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row class="no-margin-bottom layout__margin__top-minus-15" v-show="genericTemplate == false">
                                    <v-col class="templateColumn">
                                        <v-autocomplete
                                            v-model="user"
                                            :items="users"
                                            :readonly=false
                                            :rules="!genericTemplate ? userRules : []"
                                            label="User (start typing to search)"
                                            item-value="customerRef"
                                            item-text="id"
                                            :disabled="!newTemplate"
                                            persistent-hint
                                            return-object
                                        >
                                            <template slot='selection' slot-scope='{ item }'>
                                                {{ item.id }}
                                            </template>
                                            <template slot='item' slot-scope='{ item }'>
                                                {{ item.id }}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>

                                <v-row class="no-margin-bottom layout__margin__top-minus-15">
                                    <v-col>
                                        <v-checkbox
                                            class="layout__margin-0"
                                            v-model="hideTemplate"
                                            label="Hide template"
                                            required
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-form>

                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer float-right mr-4"
                                    @click="cancel()">Cancel
                            </el-button>

                            <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer float-right mr-4"
                                    @click="save()">Save
                            </el-button>
                        </div>

                        <v-snackbar v-model="uploadTemplateFailure" color="error" :top="true" :timeout="5000">
                            Sorry there has been a problem uploading your template. Please try again.
                            <v-btn dark text @click="uploadTemplateFailure = false">
                                Close
                            </v-btn>
                        </v-snackbar>
                        <v-snackbar v-model="uploadFontFailure" color="error" :top="true" :timeout="5000">
                            Sorry there has been a problem uploading your font. Please try again.
                            <v-btn dark text @click="uploadFontFailure = false">
                                Close
                            </v-btn>
                        </v-snackbar>

                    </v-container>

                    <v-overlay :value="loading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </div>
            </v-flex>

            <v-snackbar v-model="productCodesFailure" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem populating the product code dropdown. Please try again.
                <v-btn dark text @click="productCodesFailure = false">
                    Close
                </v-btn>
            </v-snackbar>

            <v-snackbar v-model="getTemplateFailure" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem populating the product code dropdown. Please try again.
                <v-btn dark text @click="getTemplateFailure = false">
                    Close
                </v-btn>
            </v-snackbar>

            <v-snackbar v-model="saveTemplateFailure" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem saving your template. Please try again.
                <v-btn dark text @click="saveTemplateFailure = false">
                    Close
                </v-btn>
            </v-snackbar>

        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        data() {
            return {
                loading: false,
                isFormValid: true,
                lazy: false,
                newTemplate: false,
                apiTemplates: [],
                stateFiles: [],
                folders: [],
                productCodes: [],
                users: [],
                validTemplate: false,
                validFont: false,
                validPreview: false,
                uploadTemplateFailure: false,
                uploadFontFailure: false,
                uploadPreviewFailure: false,
                productCodesFailure: false,
                getTemplateFailure: false,
                saveTemplateFailure: false,
                templateFile: null,
                fontFile: null,
                previewImageFront: null,
                previewImageBack: null,
                templateId: 0,
                templateName: '',
                existingFile: '',
                thumb: '',
                stateFile: '',
                folder: '',
                width: '',
                height: '',
                pages: '',
                productCode: '',
                user: '',
                testDataJson: '',
                genericTemplate: true,
                hideTemplate: false,
                customersCanvasApiKey: `${process.env.VUE_APP_CUSTOMERS_CANVAS_API_KEY}`,
                nameRules: [
                    v => !!v || 'Template name is required',
                ],
                userRules: [
                    v => !!v || 'User is required',
                ],
                fileRules: [
                    v => !!v || 'Template file is required',
                    v => (v && v.length > 0) || 'Template file is required',
                ],
			}
        },
        components: {
        },
        mixins: [axios],
        computed: {
        },
        created() {
            window.dispatchEvent(new CustomEvent('version-changed', {
                detail: {
                    storage: 'manage-templates'
                }
            }));
        },
        async mounted() {
            const getTemplates = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/FindArtworkTemplates`;
            console.log(getTemplates);

            this.apiTemplates = [];
            this.loading = true;

            await Axios.get(getTemplates)
                .then(response => {
                    response.data.result.forEach(template => {
                        if (template.isGeneric && template.isActive) {
                            this.apiTemplates.push({
                                stateId: template.masterUrl.replace('.st', '')
                            })
                        }
                    })
                })
                .catch(error => {
                    console.log(error);
                    this.loading = false;
                })

            var template = JSON.parse(window.sessionStorage.getItem('editTemplate'));
            console.log('template: ' + JSON.stringify(template));

            let getUsers = `${process.env.VUE_APP_TKGATEWAY}/odata/userSearch`;

            if (template !== null) {
                var customerRef = template.customerRef.replace('Branch: ', '');
                getUsers += '?$filter=contains(customerRef,%20%27' + customerRef + '%27)';
            }

            console.log(getUsers);

            await Axios.get(getUsers, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response);

                    let users = response.data.value;

                    for (var user, i = 0; user = users[i++];) {
                        if (user.abpUserId !== 0) {
                            this.users.push({id: user.id, ref: user.customerRef});
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.loading = false;
                })

            var endpoint = `${process.env.VUE_APP_CANVASURL}/api/users/masteruser/states?extendedStateInfo=false`;
            console.log('endpoint=' + endpoint);

            const headers = {
                "X-CustomersCanvasAPIKey": this.customersCanvasApiKey,
                "Content-Type": "application/json"
            }

            console.log(headers);

            await Axios({
                    method: 'get',
                    url: endpoint,
                    headers: headers
                })
                .then(response => {
                    console.log(response);

                    // const regexState = /DM\d{4}_RAV_.*/;
                    const regexState = /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/;
                    let stateFiles = response.data;

                    for (var stateFile, i = 0; stateFile = stateFiles[i++];) {
                        // if (regexState.test(stateFile.stateId)) {
                        if (!regexState.test(stateFile.stateId)) {
                            var index = this.apiTemplates.findIndex(x => x.stateId == stateFile.stateId); 

                            if (index === -1) {
                                this.stateFiles.push({stateId: stateFile.stateId});
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                })

            var getProductCodes = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfupload/Catalogue/FindAllProdStyles`;
            console.log(getProductCodes);

            Axios.get(getProductCodes)
                .then(response => {
                    let prodCodes = response.data;

                    for (var prodCode, i = 0; prodCode = prodCodes[i++];) {
                        if (prodCode.code == 'F001' || prodCode.code == 'F002' || prodCode.code == 'F014' || prodCode.code == 'F020') {
                            console.log(prodCode);
                            console.log(prodCode.name.split(' ')[0]);
                            this.productCodes.push({code: prodCode.code, description: prodCode.description, width: prodCode.pageWidth, height: prodCode.pageHeight, pages: prodCode.pageCount});

                            var newFolder = prodCode.description.split(' ')[0],
                                index = this.folders.findIndex(x => x.folder == newFolder); 

                            if (index === -1) {
                                this.folders.push({folder: newFolder});
                            }
                        }
                    }

                    //get existing template if applicable 
                    if (template !== null) {
                        console.log('edit template');

                        this.newTemplate = false;
                        this.templateId = template.id;
                        this.existingFile = template.filename;
                        this.templateName = template.title;
                        this.productCode = template.fCode;

                        var getTemplate = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/GetArtworkTemplateById?id=` + this.templateId;
                        console.log(getTemplate);

                        Axios.get(getTemplate, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response.data.result);

                                let templateData = response.data.result;

                                this.existingFile = templateData.masterUrl;
                                this.thumb = templateData.thumbUrl.split('||');
                                this.previewImageFront = this.thumb[0];
                                this.previewImageBack = this.thumb[1];
                                
                                this.folder = templateData.folder;
                                this.width = templateData.pageWidth;
                                this.height = templateData.pageHeight;
                                this.pages = templateData.pageCount;
                                this.genericTemplate = templateData.isGeneric;
                                this.hideTemplate = !templateData.isActive;

                                if (templateData.customerRef !== undefined && templateData.customerRef !== null) {
                                    // var getUser = `${process.env.VUE_APP_EXTERNAL_ACCOUNTS}/api/services/app/Customer/FindByRef?customerRef=` + templateData.customerRef;
                                    var getUser = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Customer/FindByRef?customerRef=` + templateData.customerRef;
                                    console.log(getUser);

                                    Axios.get(getUser, this.returnHeaderUsingToken())
                                        .then(response => {
                                            console.log(response.data.result);

                                            let userData = response.data.result;

                                            this.user = {id: userData.email + '-' + userData.ref, ref: templateData.customerRef};
                                            console.log(this.user);

                                            this.loading = false;
                                        })
                                        .catch(error => {
                                            console.log(error);

                                            this.getTemplateFailure = true;
                                            this.loading = false;
                                        })
                                } else {
                                    // No user required so finished
                                    this.loading = false;
                                }
                            })
                            .catch(error => {
                                console.log(error);

                                this.getTemplateFailure = true;
                                this.loading = false;
                            })
                    } else {
                        console.log('create template');

                        this.newTemplate = true;
                        this.loading = false;
                    }
                })
                .catch(error => {
                    console.log(error);

                    this.productCodesFailure = true;
                    this.loading = false;
                })

            // console.log('this.$refs.templateName=' + this.$refs.templateName);
            // this.$refs.templateName.focus();
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
            onTemplateFileChange() {
                console.log('this.templateFile:');
                console.log(this.templateFile);
                console.log('this.existingFile: ' + this.existingFile);
                
                if (this.templateFile == null && this.existingFile == "") {
                    this.validTemplate = false;
                    this.isFormValid = false;
                } else {
                    this.validTemplate = true;
                }

                if (this.templateFile != null && this.existingFile == "") {
                    var fileName = this.templateFile.name.replace('.idml', '');

                    this.templateName = fileName;
                    this.previewImageFront = 'https://cc.ravensworth.uk/images/' + fileName.replace(/ /g, '_') + '_Front.jpg';
                    this.previewImageBack = 'https://cc.ravensworth.uk/images/' + fileName.replace(/ /g, '_') + '_Back.jpg';
                }
            },
            onFontFileChange() {
                console.log(this.fontFile);
                
                if (this.fontFile == null) {
                    this.validFont = false;
                } else {
                    this.validFont = true;
                }
            },
            onPreviewFileChange() {
                console.log(this.previewFile);
                
                if (this.previewFile == null) {
                    this.validPreview = false;
                } else {
                    this.validPreview = true;
                }
            },
            onStateFileChange() {
                console.log(this.stateFile.stateId);

                var stateId = this.stateFile.stateId;

                this.existingFile = stateId + '.st';
                this.templateName = stateId.replace(/_/g, ' ');
                this.previewImageFront = 'https://cc.ravensworth.uk/images/' + stateId + '_Front.jpg';
                this.previewImageBack = 'https://cc.ravensworth.uk/images/' + stateId + '_Back.jpg';
            },
            onProductCodeChange() {
                console.log(this.productCode.code);
                console.log(this.productCode.description);
                console.log(this.productCode.width);
                console.log(this.productCode.height);
                console.log(this.productCode.pages);

                this.folder = this.productCode.description.split(' ')[0];
                this.width = this.productCode.width;
                this.height = this.productCode.height;
                this.pages = this.productCode.pages;

                let endpoint = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=f68371b0-ae58-4d13-91f3-11cd368b6119&orderSource=PDFUPLOAD&priceCode=' + this.productCode.code + '&quantity=1`;

                Axios.get(endpoint)
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            templates() {
                if (event.currentTarget.classList.contains('btn-disabled')) {
                    return;
                }

                console.log('templates');
                this.navigate('templates');
            },
            cancel() {
                console.log('cancel');

                this.navigate('templates');
            },
            async save() {
                console.log('save');

                console.log('this.isFormValid: ' + this.isFormValid);
                console.log('this.newTemplate: ' + this.newTemplate);
                console.log('this.templateName: ' + this.templateName);
                console.log('this.templateFile: ' + this.templateFile);
                console.log('this.validTemplate: ' + this.validTemplate);
                console.log('this.productCode: ' + this.productCode);
                console.log('this.existingFile: ' + this.existingFile);
                console.log('this.genericTemplate: ' + this.genericTemplate);
                console.log('this.user.ref: ' + this.user.ref);
                console.log('this.stateFile.stateId: ' + this.stateFile.stateId);
                console.log('typeof this.productCode: ' + typeof this.productCode);

                //check for errors
                this.$refs.form.validate();
                console.log('isFormValid=' + this.isFormValid);

                if (!this.isFormValid) {
                    return;
                }

                this.loading = true;

                var customerRef = null,
                    userId = null;

                if (!this.genericTemplate) {
                    // const customerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/FindByRef?customerRef=` + this.user.ref;
                    const customerUrl = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Customer/FindByRef?customerRef=` + this.user.ref;
                    console.log(customerUrl);
                    await Axios.get(customerUrl, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log('userId=' + response.data.result.id);

                            customerRef = this.user.ref;
                            userId = response.data.result.id;
                        })
                        .catch(error => {
                            console.log(error)

                            this.loading = false;
                            this.saveTemplateFailure = true;
                        })
                }

                if (this.newTemplate && !this.genericTemplate) {
                    var copyStateFile = 'http://designer.ravensworth.uk/copyStateFile.asp?copyFrom=masteruser&copyTo=' + this.user.ref + '&stateId=' + this.stateFile.stateId;
                    console.log(copyStateFile);

                    await Axios({
                            method: 'get',
                            url: copyStateFile,
                            crossdomain: true,
                        })
                        .then(async response => {
                            console.log(response.data);
                        })
                        .catch(error => {
                            console.log(error)

                            this.loading = false;
                            this.saveTemplateFailure = true;
                            return;
                        })
                }

                var fCode = (typeof this.productCode == 'object') ? this.productCode.code : this.productCode,
                    templateDetails;

                this.thumb = this.previewImageFront + '||' + this.previewImageBack;

                if (fCode == 'F001') {
                    this.testDataJson = '{ \"mockupFile\": \"DM A4P_1pp_GUIDE\", \"priceCodes\": [ \"F001_120_DM\" ] }';
                } else if (fCode == 'F002') {
                    this.testDataJson = '{ \"mockupFile\": \"DM A4P_1pp_GUIDE\", \"priceCodes\": [ \"F002_120_DM\" ] }';
                } else if (fCode == 'F014') {
                    this.testDataJson = '{ \"mockupFile\": \"DM A5L_2pp_GUIDE\", \"priceCodes\": [ \"F014_350_DM\", \"F014_350ML_DM\" ] }';
                } else if (fCode == 'F020') {
                    this.testDataJson = '{ \"mockupFile\": \"DM A5L_2pp_GUIDE\", \"priceCodes\": [ \"F020_350_DM\", \"F020_350ML_DM\" ] }';
                }

                if (this.newTemplate) {
                    templateDetails = {
                        "name": this.templateName,
                        "masterUrl": this.existingFile,
                        "customerRef": customerRef,
                        "fCode": fCode,
                        "thumbUrl": this.thumb,
                        "saved": this.getNow(),
                        "isActive": !this.hideTemplate,
                        "folder": this.folder,
                        "isGeneric": this.genericTemplate,
                        "pageCount": this.pages,
                        "pageHeight": this.height,
                        "pageWidth": this.width,
                        "TestDataJson": this.testDataJson,
                        "userId": userId
                    }
                } else {
                    templateDetails = {
                        "id": this.templateId,
                        "name": this.templateName,
                        "masterUrl": this.existingFile,
                        "customerRef": customerRef,
                        "fCode": fCode,
                        "thumbUrl": this.thumb,
                        "saved": this.getNow(),
                        "isActive": !this.hideTemplate,
                        "folder": this.folder,
                        "isGeneric": this.genericTemplate,
                        "pageCount": this.pages,
                        "pageHeight": this.height,
                        "pageWidth": this.width,
                        "TestDataJson": this.testDataJson,
                        "userId": userId
                    }
                }

                console.log('templateDetails: ' + JSON.stringify(templateDetails));

                if (!this.newTemplate) {
                    const url = `${process.env.VUE_APP_EXTERNAL_ACCOUNTS}/api/services/app/Artwork/DeleteArtworkTemplate?id=${this.templateId}&fromserver=0}`;

                    try {
                        await Axios.delete(url, this.returnHeaderUsingToken());
                    } catch {
                        console.log('DeleteArtworkTemplate failed');
                    }
                }

                //endpoint = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/AddArtworkTemplate`;
                var endpoint = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Artwork/AddArtworkTemplate`;

                Axios.post(endpoint, templateDetails, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response);

                        this.loading = false;
                        this.navigate('templates');
                    })
                    .catch(error => {
                        console.log(error);

                        this.loading = false;
                        this.saveTemplateFailure = true;
                    })
            },
            getNow: function() {
                const today = new Date();
                const date = today.getFullYear() + '-' + this.pad2(today.getMonth() + 1) + '-' + this.pad2(today.getDate());
                const time = this.pad2(today.getHours()) + ":" + this.pad2(today.getMinutes()) + ":" + this.pad2(today.getSeconds()) + "." + this.pad3(today.getMilliseconds());
                const dateTime = date + 'T' + time + 'Z';
                
                return dateTime;
            },
            pad2: function (value) {
                return ('00' + value).slice(-2);
            },
            pad3: function (value) {
                return ('000' + value).slice(-3);
            }
		}
    };
</script>